import { environment } from '../../environments/environment';

let url = environment.baseUrl + '/api/';

export const BASIC = {
    API: url
}
export const LOGIN = {
    TOKEN: url + 'authenticate',
    logout: url + 'Token/Logout',
    onboard: url + 'onboard',
    GET_COMPANIES: url + 'companies',
    ACTIVATE: url + 'activate',
    PASSWORD: url + 'account/change-reset-password',
    MOBILE_REGISTRATION_QR_CODE: url + 'mobile/registration',
    NOTIFICATIONS: url + 'user/alerts',
    DELETE_NOTIFICATION: url + 'remove/alert'
}

export const INST_INFO = {
    USER_DATA : url + 'account/info',
    UPLOAD_ORG_USERS: url + 'orguser/upload',
    GET_ORG_USERS: url + 'orgusers',
    FILTER_ORG_USERS : url + 'filter/orgusers',
    INVITE_USERS: url + 'email/invitation',
    GET_USER_ACTIVITY: url + 'user-activities',
    GET_USERS_REPORT: url + 'counts',
    CREATE_USER :url + 'create/admin',
    GET_INST_USERS : url + 'admin/',
    ORG_SETTINGS : url + 'institution',
    ACTIVE_DIRECTORY: url + 'enterprise/details',
    GET_REPOSITORIES: url+ 'enterprise/repositories',
    GET_REPOSITORY_BY_ID : url + 'enterpirse/repository',
    AZURE_SYNC_FULL : url + 'azure/full',
    AZURE_SYNC_DELTA : url + 'azure/delta',
    AD_SYNC_FULL : url + 'ad/full',
    AD_SYNC_DELTA : url + 'ad/delta',
    LDAP_SYNC_FULL : url + 'ldap/full',
    LDAP_SYNC_DELTA : url + 'ldap/delta',
    DB_SYNC_FULL : url + 'db/full',
    DB_SYNC_DELTA : url + 'db/delta',
    SYNC_HISTORY:url + 'repository/sync/history',
    GET_COMPLIENT: url + 'compliant',
   // ENABE_USERS: url + 'disable/orgusers',
    INVALID_USERS: url + 'invalid/orgusers',
    ORG_USER_COUNTS: url+ 'counts/alltypes',
    DELETE_ROPOSITORY: url +'delete/repository',
    CHECK_DB_CONNECTION : url + 'db/test/connection',
    INVITE_ADMINS:  url + 'invite/admins',
    GET_ANALYTICS: url + 'user/analytics',
    GET_ENROLLMENT_ANALYTICS: url + 'enrollment/analytics',
    DOWNLOAD_APPLICATION_CREDNTIALS: url + 'application/credentials',
    GET_DEVICES_COUNTS: url + 'device/enrollments',
    DONWLOAD_INVALID_USERS : url + 'invalid/orguser'
}
export const MFA ={
    SAVE_MFA_OPTIONS :url + 'mfa/options',
    SUPERADMIN_MFA_SETUP: url + 'enterprise/mfa/options',
    GET_MFA_OPTIONS :url + 'mfa/getoptions',
    GET_APPLICATIONS :url + 'applications',
    EMAIL_TEMPLATE : url + 'invitation',
    DELETE_MFA_GROUP: url + 'mfa/options',
    LOGIN_MFA: url + 'login/mfa',
    VALIDATE_OTP: url + 'otp/validation',
    LOGIN_PUSH_MFA: url + 'push/notification/authentication',
    MANAGE_APPLICATION : url + 'manage/application',
    DELETE_APPLICATIONS: url + 'delete/applications',
    APPLICATION_MFA : url + 'enable/applications',
    RADIUS_START_STOP : url + 'radius',
    REDIRECT_MFA: url + 'redirect/login/mfa',
    OTP_MFA_VALIDATION: url + 'mfa/otp/validation',
    GROUP: url + 'manage/group',
    DASHBOARD_APPLICATION_OPTIONS : url + 'mfa/application/options',
    ANALYTICS_FILTER: url + 'analytics/filter'
}
export const USER ={
    SUPPORT_TICKET :url + 'supportcases',
    CONTACT_US :  url + 'contactus',
    PROFILE: url + 'minuser',
    ADDRESS: url + 'address',
    GETADDRESS : url + 'addresses',
    STATES: url + 'states-list',
    COUNTYIES : url + 'countries-list',
    CHANGE_PASSWORD: url + 'account/change-password',
    SEND_INVITATION: url + 'device/invitation',
    SEND_SUPPORT_INVIATATION: url + 'support/device/invitation',
    GET_USER_DEVICE: url + 'devices',
    DELETE_DEVICE: url + 'delete/device',
    ADD_USER : url + 'create/orguser',
    ENABLE_MFAS : url + 'application/mfa',
    HELP_DESK_OPTIONS: url + 'helpdesk/options'
}
export const MIN_CONNECT ={
  //  SAVE_DIRECTORY: url + 'configure/authentication/details',
  //  REGISTER_RADIUS_CLIENT: url + 'radius/client',
 //   GET_RADIUS_CLIENT: url + 'radius/clients',
   // GET_PRIMARY_AUTHENTICATION_DETAILS: url + 'primary/authentication/details',
  //  DELETE_PRIMARY_REPOSITORY: url + 'primary/authentication/details',
  //  GET_CONFIGURE_MFA: url + 'configure/mfa',
   // CONFIGURE_MFA: url +'configure/mfa',
   // RADIUS_TEST: url +'radius/test',
    // PRIMARY_AUTHENTICATION_PREFERENCE : url + 'auth/preference',
  //  PRIMARY_AUTH_DETAILS: url + 'primary/auth',
    CLUSTER_IP_LIST: url + 'ecs/cluster/iplist'
}

export const MINSECURITY_ADMIN = {
    IDENTITIES: url + 'admin/identities',
    INVITE: url + 'admin/identities/invite',
    ACTIVATE: url + 'admin/identities/activate',
    LINKS: url + 'admin/identities/links',
    UNLINK: url + 'admin/identities/links/unlink',
    DISABLE: (subject: string) => url + `admin/identities/${subject}/disable`,
    ENABLE: (subject: string) => url + `admin/identities/${subject}/enable`
};